module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background-03"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "hidden-xs-only ",
    attrs: {
      "xs12": "",
      "sm2": "",
      "md2": ""
    }
  }, [_c('image-app', {
    staticClass: "animated fadeInLeft",
    attrs: {
      "imaSize": 300,
      "imaSrc": "design/banco1-1-3",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "xs12": "",
      "sm9": ""
    }
  }, [_c('ui-title-one', {
    attrs: {
      "titleAccess": "Sugerencias para ajustar el presupuesto  ",
      "titleLevel": "h1"
    }
  }, [_c('template', {
    slot: "partOne"
  }, [_vm._v(" Sugerencias para "), _c('br')]), _vm._v(" "), _c('template', {
    slot: "partTwo"
  }, [_vm._v("ajustar el ")]), _vm._v(" "), _c('template', {
    slot: "partThree"
  }, [_vm._v(" presupuesto ")])], 2)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Sugerencias para ajustar el presupuesto',
      "videoEmbed": "ADMINISTRACIONDINERO40SugerenciasAjustarPresupuesto.mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', [_vm._v("Haga clic sobre cada número para conocer las sugerencias.")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('bots-numbers-vert', {
    attrs: {
      "numeroBotones": 4
    }
  }, [_c('div', {
    staticClass: "animated fadeInRight",
    attrs: {
      "slot": "cont0"
    },
    slot: "cont0"
  }, [_c('p', [_vm._v("\n          Saque las  proporciones de gastos frente a sus ingresos, esto le ayudará a determinar qué porcentaje\n          de su ingreso se está gastando en un uso específico, o si un gasto es demasiado elevado o no.\n        ")]), _vm._v(" "), _c('image-app', {
    staticClass: "animated fadeInUp",
    attrs: {
      "imaSize": 450,
      "imaSrc": "contenido/gastos",
      "imaAlt": "Lo que usted gastó se divide en sus ingresos totales y obtiene la proporción de gastos"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "animated fadeInRight",
    attrs: {
      "slot": "cont1"
    },
    slot: "cont1"
  }, [_c('p', [_vm._v("\n          No abandone la realización de su presupuesto. Recuerde revisarlo permanentemente.\n          Sus hábitos de gasto pueden cambiar con el tiempo, por lo tanto controlar sus finanzas\n          requerirá de un esfuerzo continuo.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "animated fadeInRight",
    attrs: {
      "slot": "cont2"
    },
    slot: "cont2"
  }, [_c('p', [_vm._v("\n          Haga su presupuesto sencillo y realista.\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "animated fadeInRight",
    attrs: {
      "slot": "cont3"
    },
    slot: "cont3"
  }, [_c('p', [_vm._v("\n          Recuerde que en "), _c('strong', [_vm._v("Mi perfil")]), _vm._v(" encontrará la herramienta calculadora de presupuesto, \n          la cual le facilitará revisar y actualizar su presupuesto de forma constante.\n        ")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a83fb17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-40.vue
// module id = 1012
// module chunks = 1